$(function () {
  if (!customElements.get('member-redeem-detail')) {
    customElements.define(
      'member-redeem-detail',
      class MemberRedeemDetail extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
        }

        init() {
          const memberRedeemScrollContainer = this.querySelector('.member-redeem-scroll-container');
          this.handleScroll();

          memberRedeemScrollContainer.addEventListener('scroll', this.handleScroll.bind(this));
        }
        handleScroll() {
          const memberRedeemScrollContainer = this.querySelector('.member-redeem-scroll-container');
          const memberRedeemModalBtnRedeemWrapper = this.querySelector('.member-redeem-modal-btn-redeem_wrapper');
          const memberRedeemModalBtn = this.querySelector('.member-redeem-modal-btn');
          if (
            memberRedeemScrollContainer.scrollTop + memberRedeemScrollContainer.clientHeight >=
            memberRedeemScrollContainer.scrollHeight
          ) {
            memberRedeemModalBtnRedeemWrapper.classList.add('border-t');
            memberRedeemModalBtn.style.boxShadow = 'none';
          } else {
            memberRedeemModalBtnRedeemWrapper.classList.remove('border-t');
            memberRedeemModalBtn.style.boxShadow = '0 0 4px 0px #0000001a';
          }
        }
        disconnectedCallback() {
          const memberRedeemScrollContainer = this.querySelector('.member-redeem-scroll-container');
          memberRedeemScrollContainer.removeEventListener('scroll', this.handleScroll.bind(this));
        }
      }
    );
  }
});
